<template>
    <div id="settings_page" class="page_body">
        <h1>Settings</h1>

        <div id="tabs" v-if="user">
            <div v-on:click="selected_tab = 'account'">Account Details</div>
            <div v-if="user.user_role == 'Manager'" v-on:click="selected_tab = 'targets'">Targets</div>
            <!-- <div v-if="user.user_role === 'Manager'" v-on:click="selected_tab = 'divisions'">Divisions</div>
            <div v-if="user.user_role === 'Manager'" v-on:click="selected_tab = 'users'">Users</div>
            <div v-if="user.user_role === 'Manager'" v-on:click="selected_tab = 'columns'">Columns</div> -->
        </div>

        <div id="tab_content_wrap" v-if="user">
            <div v-if="selected_tab == 'account'" id="account_content">
                <h2>Account Details</h2>

                <ul>
                    <li><span>Email:</span> {{ user.email }}</li>
                    <li><span>Username:</span> {{ user.username }}</li>
                    <li><span>Name:</span> {{ user.name }}</li>
                    <li><span>User Role:</span> {{ user.user_role }}</li>
                </ul>
            </div>


            <CompanyTargets v-if="selected_tab == 'targets' && user.user_role == 'Manager'"/>

            <!-- <AppDivisions  v-if="selected_tab == 'divisions' && user.user_role == 'Manager'"/>

            <Users v-if="selected_tab == 'users' && user.user_role == 'Manager'"/>

            <columnSettings v-if="selected_tab == 'columns' && user.user_role == 'Manager'" /> -->
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import CompanyTargets from '../components/settings/CompanyTargets';
    // import AppDivisions from '../components/AppDivisions';
    // import Users from '../components/SettingsUsers';
    // import ColumnSettings from '../components/settings/Columns';

    export default {
        data() {
            return {
                selected_tab: 'account'
            }
        },
        computed:mapGetters(['user']),
        components: {
            CompanyTargets
        },
        methods: {
            ...mapActions(['getProfile'])
        },
        created() {
            this.getProfile();
        }
    }
</script>

<style lang="scss" scoped>
    #settings_page{
        display: flex;
        flex-wrap: wrap;
        padding:  5rem;
        background-color: #F2F2F2;

        h1{
            font-size: 3rem;
            font-weight: 700;
            line-height: 1.3;
            color: $primary-three;
            width: 100%;
            margin-bottom: 3rem;
        }

        #tabs{
            width: 40rem;
            padding: 5rem;
            background-color: #fff;

            div{
                font-size: 2rem;
                font-weight: 500;
                color: #fff;
                line-height: 1.3;
                text-align: center;
                padding: 1rem;
                margin-bottom: 1rem;
                background-color: $primary-two;
            }
        }

        #tab_content_wrap{
            background-color: #fff;
            flex-grow: 1;
            padding: 5rem;
            margin-left: 5rem;

            #account_content{
                h2{
                    font-size: 2.4rem;
                    margin-bottom: 2rem;
                }

                ul{
                    list-style-type: none;

                    li{
                        font-size: 1.6rem;
                        font-weight: 500;

                        span{
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
</style>